// Mock data for ACCI Take A Stand

export const navLinks = [
  { label: 'About Us', href: '#about' },
  { label: 'What We Do', href: '#help' },
  { label: 'Impact', href: '#impact' },
  { label: 'Community Map', href: '#community-map' },
  { label: 'Resources', href: '#resources' },
  { label: 'Stories', href: '#stories' },
];

export const heroStats = [
  { value: '38+', label: 'Years serving communities' },
  { value: '12k+', label: 'Yearly outreach appointments' },
  { value: '1 in 4', label: 'Black adults face mental ill health' },
];

export const impactStats = [
  { number: 12000, suffix: '+', label: 'Outreach appointments over a 12 month period', tone: 'aqua' },
  { number: 8400, suffix: '+', label: 'Warm, nourishing meals delivered', tone: 'purple' },
  { number: 120, suffix: '', label: 'Registered volunteers taking a stand', tone: 'aqua' },
  { number: 38, suffix: '+', label: 'Years pioneering culturally responsive care', tone: 'purple' },
];

export const waysToStand = [
  {
    id: 'donate',
    tag: 'Individuals',
    title: 'Give £5 a month',
    subtitle: 'That\u2019s just £1.25 a week',
    description: 'Your monthly gift keeps our holistic, culturally responsive mental health support running for the people who need it most. Receive our exclusive Take a Stand short film and early access to the ACCI shop.',
    cta: 'Donate monthly',
    image: 'https://images.unsplash.com/photo-1596510914965-9ae08acae566',
    accent: 'aqua',
    icon: 'HandHeart',
  },
  {
    id: 'workplace',
    tag: 'Employees',
    title: 'Nominate ACCI at work',
    subtitle: 'Charity of the Year',
    description: 'Encourage your employer to back ACCI through donation matching, staff fundraising and lasting partnerships. Download our ready-to-send email template to start the conversation.',
    cta: 'Download template',
    image: 'https://images.pexels.com/photos/3856027/pexels-photo-3856027.jpeg',
    accent: 'purple',
    icon: 'Building2',
  },
  {
    id: 'business',
    tag: 'Businesses',
    title: 'Sponsor staff wellbeing',
    subtitle: 'For sole traders & organisations',
    description: 'Partner with ACCI to educate teams on mental health disparities, share holistic wellbeing toolkits and drive meaningful community change \u2014 while supporting your own staff.',
    cta: 'Explore partnerships',
    image: 'https://images.unsplash.com/photo-1655720359248-eeace8c709c5',
    accent: 'aqua',
    icon: 'Briefcase',
  },
  {
    id: 'share',
    tag: 'Community',
    title: 'Share the message',
    subtitle: 'Strengthen our community',
    description: 'Every conversation, post and act of solidarity helps us reach more people. Download our campaign posters and share Take a Stand with your family, friends and wider community.',
    cta: 'Download posters',
    image: 'https://images.pexels.com/photos/8553332/pexels-photo-8553332.jpeg',
    accent: 'purple',
    icon: 'Megaphone',
  },
];

export const services = [
  {
    title: 'Culturally Appropriate Support',
    text: 'A culturally safe service that meets the needs of the African and Caribbean community and their families affected by mental ill health.',
  },
  {
    title: 'Outreach Support Team',
    text: 'Positive, pro-active outreach that is both practical and therapeutic \u2014 walking alongside people at every stage of their journey.',
  },
  {
    title: 'Holistic Counselling & Therapy',
    text: 'A deep and extensive counselling service rooted in community, culture and the whole person \u2014 mind, body and spirit.',
  },
  {
    title: 'Housing Advice & Information',
    text: 'We prioritise support to our members to ensure they have secure and appropriate accommodation.',
  },
  {
    title: 'Events Programme for Members',
    text: 'Our members are at the heart of everything we do \u2014 healthy outdoor activities, day trips, community sports and cultural events all year round.',
  },
  {
    title: 'Carers Support Group',
    text: 'A dedicated space for the families and carers walking beside their loved ones \u2014 because they need care too.',
  },
];

export const stories = [
  {
    name: 'Angela',
    location: 'Wolverhampton',
    role: 'Singer & Service Member',
    quote: 'ACCI\u2019s support gave me my voice back. Through their holistic care and warmth, I found my song again \u2014 literally.',
    image: 'https://images.unsplash.com/photo-1554244933-d876deb6b2ff',
  },
  {
    name: 'Jeovers',
    location: 'Black Country',
    role: 'Service Member',
    quote: 'ACCI stood beside me during my darkest days. They didn\u2019t rush me. They listened, and they walked with me.',
    image: 'https://images.unsplash.com/photo-1624272864537-8ecc72b67958',
  },
  {
    name: 'Marcus',
    location: 'Wolverhampton',
    role: 'Carer & Volunteer',
    quote: 'What ACCI offers you can\u2019t find in a clinic. It feels like family. It feels like home. It feels like healing.',
    image: 'https://images.unsplash.com/photo-1597524678053-5e6fef52d8a3',
  },
];

export const sponsors = [
  { name: 'NHS' },
  { name: 'Lloyds Bank Foundation' },
  { name: 'Wolverhampton City Council' },
  { name: 'The National Lottery' },
  { name: 'Henry Smith Charity' },
  { name: 'Tudor Trust' },
  { name: 'Independent Age' },
  { name: 'The Mount Hotel' },
];

export const events = [
  { day: '28', month: 'Jul', title: 'Community Football', time: '2pm \u2013 4pm', location: 'Wolverhampton' },
  { day: '30', month: 'Jul', title: 'Free Health Checks', time: '10:30am \u2013 12pm', location: 'Wolverhampton' },
  { day: '31', month: 'Jul', title: 'Merchandise Club', time: '2:30pm \u2013 3:30pm', location: 'Wolverhampton' },
];

export const donationTiers = [
  { amount: 5, label: 'A Seed', desc: 'A warm meal for a service member', popular: false },
  { amount: 15, label: 'A Stand', desc: 'An hour of holistic counselling', popular: true },
  { amount: 30, label: 'A Bridge', desc: 'An outreach visit for someone in crisis', popular: false },
  { amount: 50, label: 'A Legacy', desc: 'A week of community wellbeing', popular: false },
];

// Live Impact Dashboard — annual fundraising target and rolling totals.
export const donationDashboard = {
  goal: 250000,
  baseRaised: 187420,
  baseDonors: 1284,
  hoursCounselling: 3210,
  mealsDelivered: 8412,
};

// Community Map — Black Country pins (Wolverhampton, Walsall, Dudley, Sandwell)
export const mapPins = [
  {
    id: 'w1',
    type: 'event',
    title: 'Community Football',
    detail: 'Sat 28 Jul · 2pm – 4pm',
    body: 'Free 5-a-side session for members, families and friends.',
    address: 'Aldersley Leisure Village, Wolverhampton',
    lat: 52.6013,
    lng: -2.1583,
  },
  {
    id: 'w2',
    type: 'event',
    title: 'Free Health Checks',
    detail: 'Tue 30 Jul · 10:30am – 12pm',
    body: 'Blood pressure, wellbeing chats and holistic screening.',
    address: 'ACCI Centre, Wolverhampton',
    lat: 52.5862,
    lng: -2.1288,
  },
  {
    id: 'w3',
    type: 'volunteer',
    title: 'Outreach Befriender',
    detail: 'Flexible · 2–4 hrs / week',
    body: 'Walk alongside members with weekly check-ins and warm visits.',
    address: 'Wolverhampton area',
    lat: 52.5895,
    lng: -2.1120,
  },
  {
    id: 'wl1',
    type: 'event',
    title: 'Carers Circle',
    detail: 'Thu 1 Aug · 6pm – 7:30pm',
    body: 'A gentle space for the people caring for loved ones.',
    address: 'Walsall Community Hub',
    lat: 52.5862,
    lng: -1.9822,
  },
  {
    id: 'wl2',
    type: 'volunteer',
    title: 'Kitchen Volunteer',
    detail: 'Sundays · 10am – 1pm',
    body: 'Help prepare nourishing meals for our outreach programme.',
    address: 'Walsall Kitchen Partnership',
    lat: 52.5721,
    lng: -1.9740,
  },
  {
    id: 'd1',
    type: 'event',
    title: 'Wellbeing Walk',
    detail: 'Sun 4 Aug · 11am – 12:30pm',
    body: 'Gentle guided walk with tea, poetry and community.',
    address: 'Priory Park, Dudley',
    lat: 52.5085,
    lng: -2.0870,
  },
  {
    id: 'd2',
    type: 'volunteer',
    title: 'Events Assistant',
    detail: 'Ad-hoc · Weekends',
    body: 'Support set-up, welcome guests and share the ACCI story.',
    address: 'Dudley venues',
    lat: 52.5121,
    lng: -2.0810,
  },
  {
    id: 's1',
    type: 'event',
    title: 'Youth Wellbeing Night',
    detail: 'Fri 9 Aug · 6pm – 8pm',
    body: 'Games, DJ set and drop-in with our youth workers.',
    address: 'Smethwick Youth Centre, Sandwell',
    lat: 52.4990,
    lng: -1.9686,
  },
  {
    id: 's2',
    type: 'volunteer',
    title: 'Digital Storyteller',
    detail: '1–2 hrs / week',
    body: 'Capture short stories from members for social media.',
    address: 'Sandwell area',
    lat: 52.5060,
    lng: -1.9950,
  },
];

// Digital Resources — social media toolkit
export const socialPosts = [
  {
    id: 'p1',
    platform: 'Instagram / Facebook',
    caption:
      "Today I'm taking a stand with @ACCI_UK for holistic, culturally responsive mental health care in our community. 1 in 4 Black adults face mental ill health — and 38+ years on, ACCI is still showing up. Join me: acci.org.uk/take-a-stand #TakeAStandACCI",
  },
  {
    id: 'p2',
    platform: 'X / Twitter',
    caption:
      "I'm standing with @ACCI_UK. 38+ years of culturally responsive mental health care for the African & Caribbean community. Your £5 keeps a door open. Take a stand → acci.org.uk/take-a-stand #TakeAStandACCI #HolisticCare",
  },
  {
    id: 'p3',
    platform: 'LinkedIn',
    caption:
      "Mental health support is not one-size-fits-all. ACCI has spent 38 years building holistic, culturally safe care for the African & Caribbean community in the Black Country. This month I'm asking my network to Take A Stand — nominate ACCI as your Charity of the Year, or share their work. #TakeAStandACCI #Wellbeing #Community",
  },
  {
    id: 'p4',
    platform: 'WhatsApp / SMS',
    caption:
      "Hi — I'm supporting ACCI's Take A Stand campaign for culturally responsive mental health care in our community. Even £5 a month keeps the doors open. Have a look: acci.org.uk/take-a-stand 💜",
  },
];

export const hashtagBank = [
  '#TakeAStandACCI',
  '#ACCI',
  '#HolisticCare',
  '#BlackMentalHealth',
  '#BlackCountry',
  '#Wolverhampton',
  '#CulturallyResponsive',
  '#CommunityFirst',
  '#WellbeingForAll',
  '#StandTogether',
];

export const digitalAssets = [
  {
    id: 'a1',
    title: 'Campaign Poster (A4)',
    format: 'PDF · Print & pin',
    tone: 'purple',
    icon: 'FileImage',
  },
  {
    id: 'a2',
    title: 'Instagram Story Pack',
    format: '1080×1920 · 6 frames',
    tone: 'aqua',
    icon: 'Instagram',
  },
  {
    id: 'a3',
    title: 'Square Social Tiles',
    format: '1080×1080 · 4 tiles',
    tone: 'purple',
    icon: 'Image',
  },
  {
    id: 'a4',
    title: 'Zoom / Teams Background',
    format: '1920×1080 · Branded',
    tone: 'aqua',
    icon: 'Monitor',
  },
  {
    id: 'a5',
    title: 'Email Signature Banner',
    format: '600×150 · PNG',
    tone: 'purple',
    icon: 'Mail',
  },
  {
    id: 'a6',
    title: 'Workplace Email Template',
    format: 'DOCX · Charity of the Year ask',
    tone: 'aqua',
    icon: 'FileText',
  },
];
